import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

const Placeholder = ({ message }) => {
  return (
    <Paper>
      <Grid container alignItems='center' justifyContent='center'>
        <Grid item>
          <ErrorIcon />
        </Grid>
        <Grid item>{message}</Grid>
      </Grid>
    </Paper>
  );
};

Placeholder.propTypes = {
  message: PropTypes.string.isRequired
};

export default Placeholder;
